import { format } from "date-fns";
import { fr as loc } from "date-fns/locale";
import { utcToZonedTime } from "date-fns-tz";

export function getBrowserTimeZone() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export function ToUtc(d: Date) {
  return utcToZonedTime(d, getBrowserTimeZone());
}

export function formatDate(d: Date) {
  const tmp = utcToZonedTime(d, getBrowserTimeZone());
  const res = format(tmp, "dd/MM/yyyy", { locale: loc });
  return res;
}

export function formatDateWithDayOfWeek(d: Date) {
  const tmp = utcToZonedTime(d, getBrowserTimeZone());
  const res = format(tmp, "EEEE dd/MM", { locale: loc });
  return res;
}

export function formatDateWithHour(d: Date) {
  const tmp = utcToZonedTime(d, getBrowserTimeZone());
  const res = format(tmp, "dd/MM/yyyy HH:mm", { locale: loc });
  return res;
}

export function getDateHour(d: Date) {
  const tmp = utcToZonedTime(d, getBrowserTimeZone());
  const res = format(tmp, "HH:mm", { locale: loc });
  return res;
}
